import { BodyM } from '@casavo/base-ui'
import React from 'react'

import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

/**
 * Due to France regulation
 * for more legal info, see https://www.inc-conso.fr/content/1er-janvier-2023-une-information-renforcee-des-acquereurs-et-des-locataires-sur-les-risques
 *
 * @param country
 */
export const FranceGeologicalRiskDisclaimer: React.FC<{
  country: CateCountry
}> = ({ country }) => {
  const isFrance = country === 'france'

  const href = 'https://www.georisques.gouv.fr'

  return (
    <div>
      {isFrance && (
        <div
          className={sprinkles({ marginBottom: 'm', marginTop: 'xl' })}
        >
          <BodyM>Les informations sur les risques auxquels ce bien est exposé sont disponibles sur le site Géorisques
            : <a href={href} rel={'noreferrer nofollow'}
                 target={'_blank'}>www.georisques.gouv.fr</a></BodyM>
        </div>
      )}
    </div>
  )
}
